export default function makeJavascriptReadable(data) {
    if (Object.prototype.toString.call(data) === '[object String]') {
        return data;
    }

    if (['[object Object]', '[object Array]'].includes(Object.prototype.toString.call(data))) {
        return JSON.stringify(data, null, 4);
    }

    return String(data);
}
